export const AUTH = {
  URL: process.env.REACT_APP_AUTH_URL,
  EXPIRATION_MULTIPLIER: 1000,
  REDIRECT_PARAM: 'redirect_url',
  LOGIN_PATH: '/',
};
